module.exports = __webpack_public_path__ + "img/symbol_color.7f6800a1.svg";